import React from 'react';

import {css} from 'emotion';
import PropTypes from 'prop-types';

import {ulStyle} from './style';

const propTypes = {
  additionalClassName: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export const NavMenuList = (props) => {
  const {additionalClassName, children} = props;
  return (
    <ul
      className={css(ulStyle, additionalClassName || null)}
    >
      {children}
    </ul>
  );
};

NavMenuList.propTypes = propTypes;

export default NavMenuList;
